<template>
  <v-list-item
      :to="{ name: 'car-view', params: { id: id }}"
      target="_blank"
      class="align-self-start"
  >
    <v-col
        cols="12"
        class="py-0"
    >
      <v-row no-gutters="true">
        <p class="text-subtitle-1">{{ title }}</p>
      </v-row>
      <v-row no-gutters="true">
        <v-col>
          <p class="text-h6 font-weight-bold text-no-wrap text-center">{{ firstPrice }}</p>
        </v-col>
        <v-col>
          <p class="text-h6 font-weight-bold text-no-wrap text-center">{{ secondPrice }}</p>
        </v-col>
        <v-col>
          <p class="text-h6 font-weight-bold text-no-wrap text-center">{{ thirdPrice }}</p>
        </v-col>
      </v-row>
    </v-col>
    <v-col
        cols="12"
        class="py-0"
    >
      <v-img
          :src="mainPhoto"
          class="rounded"
          height="250"
          width="300"
      />
    </v-col>
    <v-col
        cols="12"
        md="8"
        class="px-0 px-md-2 pt-2 pt-md-0"
    >
      <v-row no-gutters="true">
        <v-col>
          <p class="font-weight-regular">{{ subtitle }}</p>
        </v-col>
      </v-row>
    </v-col>
  </v-list-item>
</template>

<script>
export default {
  name: "CarAdListItem",
  props: {
    index: Number,
    id: String,
    title: String,
    firstPrice: String,
    secondPrice: String,
    thirdPrice: String,
    subtitle: String,
    description: String,
    mainPhoto: String
  }
}
</script>

<style scoped>

</style>